unit Unit2;

interface

uses
  SysUtils, Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, WEBLib.StdCtrls, WEBLib.ExtCtrls;

type
  TForm2 = class(TForm)
    WebGroupBox4: TGroupBox;
    WebLabel66: TLabel;
    WebLabel68: TLabel;
    WebLabel71: TLabel;
    WebLabel75: TLabel;
    WebLabel77: TLabel;
    WebLabel79: TLabel;
    WebLabel80: TLabel;
    WebLabel85: TLabel;
    WebLabel87: TLabel;
    WebLabel89: TLabel;
    WebLabel91: TLabel;
    WebEdit36: TEdit;
    WebEdit37: TEdit;
    WebEdit38: TEdit;
    WebEdit39: TEdit;
    WebEdit40: TEdit;
    WebEdit41: TEdit;
    WebEdit42: TEdit;
    WebEdit43: TEdit;
    WebEdit44: TEdit;
    WebEdit45: TEdit;
    WebEdit46: TEdit;
    WebEdit1: TEdit;
    WebEdit2: TEdit;
    WebEdit3: TEdit;
    WebEdit4: TEdit;
    WebEdit5: TEdit;
    WebEdit6: TEdit;
    WebEdit7: TEdit;
    WebEdit8: TEdit;
    WebEdit9: TEdit;
    WebEdit10: TEdit;
    WebEdit11: TEdit;
    WebEdit12: TEdit;
    WebEdit13: TEdit;
    WebEdit14: TEdit;
    WebEdit15: TEdit;
    WebEdit16: TEdit;
    WebEdit17: TEdit;
    WebEdit18: TEdit;
    WebEdit19: TEdit;
    WebEdit20: TEdit;
    WebEdit21: TEdit;
    WebEdit22: TEdit;
    WebEdit23: TEdit;
    WebEdit24: TEdit;
    WebEdit25: TEdit;
    WebEdit26: TEdit;
    WebEdit27: TEdit;
    WebEdit28: TEdit;
    WebEdit29: TEdit;
    WebEdit30: TEdit;
    WebEdit31: TEdit;
    WebEdit32: TEdit;
    WebEdit33: TEdit;
    WebEdit34: TEdit;
    WebEdit35: TEdit;
    WebEdit47: TEdit;
    WebEdit48: TEdit;
    WebEdit49: TEdit;
    WebEdit50: TEdit;
    WebEdit51: TEdit;
    WebEdit52: TEdit;
    WebEdit53: TEdit;
    WebEdit54: TEdit;
    WebEdit55: TEdit;
    WebLabel1: TLabel;
    WebLabel7: TLabel;
  private
    { Private declarations }
  protected
    procedure LoadDFMValues; override;
  public
    { Public declarations }
  end;

var
  Form2: TForm2;

implementation


procedure TForm2.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebLabel1 := TLabel.Create(Self);
  WebLabel7 := TLabel.Create(Self);
  WebGroupBox4 := TGroupBox.Create(Self);
  WebLabel66 := TLabel.Create(Self);
  WebLabel68 := TLabel.Create(Self);
  WebLabel71 := TLabel.Create(Self);
  WebLabel75 := TLabel.Create(Self);
  WebLabel77 := TLabel.Create(Self);
  WebLabel79 := TLabel.Create(Self);
  WebLabel80 := TLabel.Create(Self);
  WebLabel85 := TLabel.Create(Self);
  WebLabel87 := TLabel.Create(Self);
  WebLabel89 := TLabel.Create(Self);
  WebLabel91 := TLabel.Create(Self);
  WebEdit36 := TEdit.Create(Self);
  WebEdit37 := TEdit.Create(Self);
  WebEdit38 := TEdit.Create(Self);
  WebEdit39 := TEdit.Create(Self);
  WebEdit40 := TEdit.Create(Self);
  WebEdit41 := TEdit.Create(Self);
  WebEdit42 := TEdit.Create(Self);
  WebEdit43 := TEdit.Create(Self);
  WebEdit44 := TEdit.Create(Self);
  WebEdit45 := TEdit.Create(Self);
  WebEdit46 := TEdit.Create(Self);
  WebEdit1 := TEdit.Create(Self);
  WebEdit2 := TEdit.Create(Self);
  WebEdit3 := TEdit.Create(Self);
  WebEdit4 := TEdit.Create(Self);
  WebEdit5 := TEdit.Create(Self);
  WebEdit6 := TEdit.Create(Self);
  WebEdit7 := TEdit.Create(Self);
  WebEdit8 := TEdit.Create(Self);
  WebEdit9 := TEdit.Create(Self);
  WebEdit10 := TEdit.Create(Self);
  WebEdit11 := TEdit.Create(Self);
  WebEdit12 := TEdit.Create(Self);
  WebEdit13 := TEdit.Create(Self);
  WebEdit14 := TEdit.Create(Self);
  WebEdit15 := TEdit.Create(Self);
  WebEdit16 := TEdit.Create(Self);
  WebEdit17 := TEdit.Create(Self);
  WebEdit18 := TEdit.Create(Self);
  WebEdit19 := TEdit.Create(Self);
  WebEdit20 := TEdit.Create(Self);
  WebEdit21 := TEdit.Create(Self);
  WebEdit22 := TEdit.Create(Self);
  WebEdit23 := TEdit.Create(Self);
  WebEdit24 := TEdit.Create(Self);
  WebEdit25 := TEdit.Create(Self);
  WebEdit26 := TEdit.Create(Self);
  WebEdit27 := TEdit.Create(Self);
  WebEdit28 := TEdit.Create(Self);
  WebEdit29 := TEdit.Create(Self);
  WebEdit30 := TEdit.Create(Self);
  WebEdit31 := TEdit.Create(Self);
  WebEdit32 := TEdit.Create(Self);
  WebEdit33 := TEdit.Create(Self);
  WebEdit34 := TEdit.Create(Self);
  WebEdit35 := TEdit.Create(Self);
  WebEdit47 := TEdit.Create(Self);
  WebEdit48 := TEdit.Create(Self);
  WebEdit49 := TEdit.Create(Self);
  WebEdit50 := TEdit.Create(Self);
  WebEdit51 := TEdit.Create(Self);
  WebEdit52 := TEdit.Create(Self);
  WebEdit53 := TEdit.Create(Self);
  WebEdit54 := TEdit.Create(Self);
  WebEdit55 := TEdit.Create(Self);

  WebLabel1.BeforeLoadDFMValues;
  WebLabel7.BeforeLoadDFMValues;
  WebGroupBox4.BeforeLoadDFMValues;
  WebLabel66.BeforeLoadDFMValues;
  WebLabel68.BeforeLoadDFMValues;
  WebLabel71.BeforeLoadDFMValues;
  WebLabel75.BeforeLoadDFMValues;
  WebLabel77.BeforeLoadDFMValues;
  WebLabel79.BeforeLoadDFMValues;
  WebLabel80.BeforeLoadDFMValues;
  WebLabel85.BeforeLoadDFMValues;
  WebLabel87.BeforeLoadDFMValues;
  WebLabel89.BeforeLoadDFMValues;
  WebLabel91.BeforeLoadDFMValues;
  WebEdit36.BeforeLoadDFMValues;
  WebEdit37.BeforeLoadDFMValues;
  WebEdit38.BeforeLoadDFMValues;
  WebEdit39.BeforeLoadDFMValues;
  WebEdit40.BeforeLoadDFMValues;
  WebEdit41.BeforeLoadDFMValues;
  WebEdit42.BeforeLoadDFMValues;
  WebEdit43.BeforeLoadDFMValues;
  WebEdit44.BeforeLoadDFMValues;
  WebEdit45.BeforeLoadDFMValues;
  WebEdit46.BeforeLoadDFMValues;
  WebEdit1.BeforeLoadDFMValues;
  WebEdit2.BeforeLoadDFMValues;
  WebEdit3.BeforeLoadDFMValues;
  WebEdit4.BeforeLoadDFMValues;
  WebEdit5.BeforeLoadDFMValues;
  WebEdit6.BeforeLoadDFMValues;
  WebEdit7.BeforeLoadDFMValues;
  WebEdit8.BeforeLoadDFMValues;
  WebEdit9.BeforeLoadDFMValues;
  WebEdit10.BeforeLoadDFMValues;
  WebEdit11.BeforeLoadDFMValues;
  WebEdit12.BeforeLoadDFMValues;
  WebEdit13.BeforeLoadDFMValues;
  WebEdit14.BeforeLoadDFMValues;
  WebEdit15.BeforeLoadDFMValues;
  WebEdit16.BeforeLoadDFMValues;
  WebEdit17.BeforeLoadDFMValues;
  WebEdit18.BeforeLoadDFMValues;
  WebEdit19.BeforeLoadDFMValues;
  WebEdit20.BeforeLoadDFMValues;
  WebEdit21.BeforeLoadDFMValues;
  WebEdit22.BeforeLoadDFMValues;
  WebEdit23.BeforeLoadDFMValues;
  WebEdit24.BeforeLoadDFMValues;
  WebEdit25.BeforeLoadDFMValues;
  WebEdit26.BeforeLoadDFMValues;
  WebEdit27.BeforeLoadDFMValues;
  WebEdit28.BeforeLoadDFMValues;
  WebEdit29.BeforeLoadDFMValues;
  WebEdit30.BeforeLoadDFMValues;
  WebEdit31.BeforeLoadDFMValues;
  WebEdit32.BeforeLoadDFMValues;
  WebEdit33.BeforeLoadDFMValues;
  WebEdit34.BeforeLoadDFMValues;
  WebEdit35.BeforeLoadDFMValues;
  WebEdit47.BeforeLoadDFMValues;
  WebEdit48.BeforeLoadDFMValues;
  WebEdit49.BeforeLoadDFMValues;
  WebEdit50.BeforeLoadDFMValues;
  WebEdit51.BeforeLoadDFMValues;
  WebEdit52.BeforeLoadDFMValues;
  WebEdit53.BeforeLoadDFMValues;
  WebEdit54.BeforeLoadDFMValues;
  WebEdit55.BeforeLoadDFMValues;
  try
    Name := 'Form2';
    Left := 0;
    Top := 0;
    Width := 640;
    Height := 430;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    TabOrder := 1;
    WebLabel1.SetParentComponent(Self);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 8;
    WebLabel1.Top := 5;
    WebLabel1.Width := 131;
    WebLabel1.Height := 16;
    WebLabel1.Caption := 'Kalkulacja Cash Flow';
    WebLabel1.Font.Charset := DEFAULT_CHARSET;
    WebLabel1.Font.Color := clMenuHighlight;
    WebLabel1.Font.Height := 16;
    WebLabel1.Font.Name := 'Tahoma';
    WebLabel1.Font.Style := [fsBold];
    WebLabel1.ParentFont := False;
    WebLabel7.SetParentComponent(Self);
    WebLabel7.Name := 'WebLabel7';
    WebLabel7.Left := 8;
    WebLabel7.Top := 406;
    WebLabel7.Width := 204;
    WebLabel7.Height := 13;
    WebLabel7.Caption := 'Kalkulator wycena firmy - Biz24.pl (c) 2020';
    WebLabel7.Color := clYellow;
    WebLabel7.Transparent := False;
    WebGroupBox4.SetParentComponent(Self);
    WebGroupBox4.Name := 'WebGroupBox4';
    WebGroupBox4.Left := 8;
    WebGroupBox4.Top := 27;
    WebGroupBox4.Width := 620;
    WebGroupBox4.Height := 373;
    WebGroupBox4.Caption := 'Kalkulacja Cash Flow ';
    WebGroupBox4.ChildOrder := 27;
    WebLabel66.SetParentComponent(WebGroupBox4);
    WebLabel66.Name := 'WebLabel66';
    WebLabel66.Left := 18;
    WebLabel66.Top := 29;
    WebLabel66.Width := 22;
    WebLabel66.Height := 13;
    WebLabel66.Caption := 'Rok';
    WebLabel66.Font.Charset := DEFAULT_CHARSET;
    WebLabel66.Font.Color := clWindowText;
    WebLabel66.Font.Height := -11;
    WebLabel66.Font.Name := 'Tahoma';
    WebLabel66.Font.Style := [fsBold];
    WebLabel66.ParentFont := False;
    WebLabel68.SetParentComponent(WebGroupBox4);
    WebLabel68.Name := 'WebLabel68';
    WebLabel68.Left := 18;
    WebLabel68.Top := 68;
    WebLabel68.Width := 147;
    WebLabel68.Height := 13;
    WebLabel68.Caption := 'Wynik firmy po opodatkowaniu';
    WebLabel71.SetParentComponent(WebGroupBox4);
    WebLabel71.Name := 'WebLabel71';
    WebLabel71.Left := 18;
    WebLabel71.Top := 93;
    WebLabel71.Width := 91;
    WebLabel71.Height := 13;
    WebLabel71.Caption := 'Potencja'#322'y synergii';
    WebLabel75.SetParentComponent(WebGroupBox4);
    WebLabel75.Name := 'WebLabel75';
    WebLabel75.Left := 18;
    WebLabel75.Top := 118;
    WebLabel75.Width := 134;
    WebLabel75.Height := 13;
    WebLabel75.Caption := 'Inne potencjalne przychody';
    WebLabel77.SetParentComponent(WebGroupBox4);
    WebLabel77.Name := 'WebLabel77';
    WebLabel77.Left := 18;
    WebLabel77.Top := 143;
    WebLabel77.Width := 110;
    WebLabel77.Height := 13;
    WebLabel77.Caption := 'Koszty restrukturyzacji';
    WebLabel79.SetParentComponent(WebGroupBox4);
    WebLabel79.Name := 'WebLabel79';
    WebLabel79.Left := 18;
    WebLabel79.Top := 168;
    WebLabel79.Width := 36;
    WebLabel79.Height := 13;
    WebLabel79.Caption := 'Odsetki';
    WebLabel80.SetParentComponent(WebGroupBox4);
    WebLabel80.Name := 'WebLabel80';
    WebLabel80.Left := 18;
    WebLabel80.Top := 207;
    WebLabel80.Width := 178;
    WebLabel80.Height := 13;
    WebLabel80.Caption := 'Wnykik przed opodatkowaniem';
    WebLabel80.Font.Charset := DEFAULT_CHARSET;
    WebLabel80.Font.Color := clWindowText;
    WebLabel80.Font.Height := -11;
    WebLabel80.Font.Name := 'Tahoma';
    WebLabel80.Font.Style := [fsBold];
    WebLabel80.ParentFont := False;
    WebLabel85.SetParentComponent(WebGroupBox4);
    WebLabel85.Name := 'WebLabel85';
    WebLabel85.Left := 18;
    WebLabel85.Top := 247;
    WebLabel85.Width := 60;
    WebLabel85.Height := 13;
    WebLabel85.Caption := 'Amortyzacja';
    WebLabel87.SetParentComponent(WebGroupBox4);
    WebLabel87.Name := 'WebLabel87';
    WebLabel87.Left := 17;
    WebLabel87.Top := 272;
    WebLabel87.Width := 47;
    WebLabel87.Height := 13;
    WebLabel87.Caption := 'Iwestycje';
    WebLabel89.SetParentComponent(WebGroupBox4);
    WebLabel89.Name := 'WebLabel89';
    WebLabel89.Left := 17;
    WebLabel89.Top := 297;
    WebLabel89.Width := 137;
    WebLabel89.Height := 13;
    WebLabel89.Caption := 'Zmiana '#347'rodk'#243'w obrotowych';
    WebLabel91.SetParentComponent(WebGroupBox4);
    WebLabel91.Name := 'WebLabel91';
    WebLabel91.Left := 17;
    WebLabel91.Top := 334;
    WebLabel91.Width := 58;
    WebLabel91.Height := 13;
    WebLabel91.Caption := 'Cash Flow ';
    WebLabel91.Font.Charset := DEFAULT_CHARSET;
    WebLabel91.Font.Color := clWindowText;
    WebLabel91.Font.Height := -11;
    WebLabel91.Font.Name := 'Tahoma';
    WebLabel91.Font.Style := [fsBold];
    WebLabel91.ParentFont := False;
    WebEdit36.SetParentComponent(WebGroupBox4);
    WebEdit36.Name := 'WebEdit36';
    WebEdit36.Left := 233;
    WebEdit36.Top := 65;
    WebEdit36.Width := 61;
    WebEdit36.Height := 19;
    WebEdit36.ChildOrder := 1;
    WebEdit36.Color := 12903679;
    WebEdit36.Enabled := False;
    WebEdit36.Text := '300000';
    WebEdit37.SetParentComponent(WebGroupBox4);
    WebEdit37.Name := 'WebEdit37';
    WebEdit37.Left := 233;
    WebEdit37.Top := 90;
    WebEdit37.Width := 61;
    WebEdit37.Height := 19;
    WebEdit37.ChildOrder := 2;
    WebEdit37.Color := clInfoBk;
    WebEdit37.Text := '0';
    WebEdit38.SetParentComponent(WebGroupBox4);
    WebEdit38.Name := 'WebEdit38';
    WebEdit38.Left := 233;
    WebEdit38.Top := 115;
    WebEdit38.Width := 61;
    WebEdit38.Height := 19;
    WebEdit38.ChildOrder := 3;
    WebEdit38.Color := clInfoBk;
    WebEdit38.Text := '0';
    WebEdit39.SetParentComponent(WebGroupBox4);
    WebEdit39.Name := 'WebEdit39';
    WebEdit39.Left := 233;
    WebEdit39.Top := 140;
    WebEdit39.Width := 61;
    WebEdit39.Height := 19;
    WebEdit39.ChildOrder := 4;
    WebEdit39.Color := clInfoBk;
    WebEdit39.Text := '20000';
    WebEdit40.SetParentComponent(WebGroupBox4);
    WebEdit40.Name := 'WebEdit40';
    WebEdit40.Left := 233;
    WebEdit40.Top := 165;
    WebEdit40.Width := 61;
    WebEdit40.Height := 19;
    WebEdit40.ChildOrder := 5;
    WebEdit40.Color := clInfoBk;
    WebEdit40.Text := '50000';
    WebEdit41.SetParentComponent(WebGroupBox4);
    WebEdit41.Name := 'WebEdit41';
    WebEdit41.Left := 233;
    WebEdit41.Top := 204;
    WebEdit41.Width := 61;
    WebEdit41.Height := 19;
    WebEdit41.ChildOrder := 6;
    WebEdit41.Color := 12903679;
    WebEdit41.Text := '330000';
    WebEdit42.SetParentComponent(WebGroupBox4);
    WebEdit42.Name := 'WebEdit42';
    WebEdit42.Left := 233;
    WebEdit42.Top := 244;
    WebEdit42.Width := 61;
    WebEdit42.Height := 19;
    WebEdit42.ChildOrder := 7;
    WebEdit42.Color := 12903679;
    WebEdit42.Enabled := False;
    WebEdit42.Text := '100000';
    WebEdit43.SetParentComponent(WebGroupBox4);
    WebEdit43.Name := 'WebEdit43';
    WebEdit43.Left := 233;
    WebEdit43.Top := 26;
    WebEdit43.Width := 61;
    WebEdit43.Height := 19;
    WebEdit43.ChildOrder := 8;
    WebEdit43.Color := 12903679;
    WebEdit43.Enabled := False;
    WebEdit43.Text := '2020';
    WebEdit44.SetParentComponent(WebGroupBox4);
    WebEdit44.Name := 'WebEdit44';
    WebEdit44.Left := 232;
    WebEdit44.Top := 269;
    WebEdit44.Width := 61;
    WebEdit44.Height := 19;
    WebEdit44.ChildOrder := 7;
    WebEdit44.Color := clInfoBk;
    WebEdit44.Text := '0';
    WebEdit45.SetParentComponent(WebGroupBox4);
    WebEdit45.Name := 'WebEdit45';
    WebEdit45.Left := 232;
    WebEdit45.Top := 294;
    WebEdit45.Width := 61;
    WebEdit45.Height := 19;
    WebEdit45.ChildOrder := 7;
    WebEdit45.Color := clInfoBk;
    WebEdit45.Text := '0';
    WebEdit46.SetParentComponent(WebGroupBox4);
    WebEdit46.Name := 'WebEdit46';
    WebEdit46.Left := 232;
    WebEdit46.Top := 331;
    WebEdit46.Width := 61;
    WebEdit46.Height := 19;
    WebEdit46.ChildOrder := 7;
    WebEdit46.Color := 12903679;
    WebEdit46.Enabled := False;
    WebEdit46.Text := '430000';
    WebEdit1.SetParentComponent(WebGroupBox4);
    WebEdit1.Name := 'WebEdit1';
    WebEdit1.Left := 303;
    WebEdit1.Top := 26;
    WebEdit1.Width := 61;
    WebEdit1.Height := 19;
    WebEdit1.ChildOrder := 8;
    WebEdit1.Color := 12903679;
    WebEdit1.Enabled := False;
    WebEdit1.Text := '2021';
    WebEdit2.SetParentComponent(WebGroupBox4);
    WebEdit2.Name := 'WebEdit2';
    WebEdit2.Left := 303;
    WebEdit2.Top := 65;
    WebEdit2.Width := 61;
    WebEdit2.Height := 19;
    WebEdit2.ChildOrder := 1;
    WebEdit2.Color := clInfoBk;
    WebEdit2.Text := '320000';
    WebEdit3.SetParentComponent(WebGroupBox4);
    WebEdit3.Name := 'WebEdit3';
    WebEdit3.Left := 303;
    WebEdit3.Top := 90;
    WebEdit3.Width := 61;
    WebEdit3.Height := 19;
    WebEdit3.ChildOrder := 2;
    WebEdit3.Color := clInfoBk;
    WebEdit3.Text := '0';
    WebEdit4.SetParentComponent(WebGroupBox4);
    WebEdit4.Name := 'WebEdit4';
    WebEdit4.Left := 303;
    WebEdit4.Top := 115;
    WebEdit4.Width := 61;
    WebEdit4.Height := 19;
    WebEdit4.ChildOrder := 3;
    WebEdit4.Color := clInfoBk;
    WebEdit4.Text := '0';
    WebEdit5.SetParentComponent(WebGroupBox4);
    WebEdit5.Name := 'WebEdit5';
    WebEdit5.Left := 303;
    WebEdit5.Top := 140;
    WebEdit5.Width := 61;
    WebEdit5.Height := 19;
    WebEdit5.ChildOrder := 4;
    WebEdit5.Color := clInfoBk;
    WebEdit5.Text := '20000';
    WebEdit6.SetParentComponent(WebGroupBox4);
    WebEdit6.Name := 'WebEdit6';
    WebEdit6.Left := 303;
    WebEdit6.Top := 165;
    WebEdit6.Width := 61;
    WebEdit6.Height := 19;
    WebEdit6.ChildOrder := 5;
    WebEdit6.Color := clInfoBk;
    WebEdit6.Text := '30000';
    WebEdit7.SetParentComponent(WebGroupBox4);
    WebEdit7.Name := 'WebEdit7';
    WebEdit7.Left := 303;
    WebEdit7.Top := 204;
    WebEdit7.Width := 61;
    WebEdit7.Height := 19;
    WebEdit7.ChildOrder := 6;
    WebEdit7.Color := 12903679;
    WebEdit7.Enabled := False;
    WebEdit7.Text := '330000';
    WebEdit8.SetParentComponent(WebGroupBox4);
    WebEdit8.Name := 'WebEdit8';
    WebEdit8.Left := 303;
    WebEdit8.Top := 244;
    WebEdit8.Width := 61;
    WebEdit8.Height := 19;
    WebEdit8.ChildOrder := 7;
    WebEdit8.Color := clInfoBk;
    WebEdit8.Text := '100000';
    WebEdit9.SetParentComponent(WebGroupBox4);
    WebEdit9.Name := 'WebEdit9';
    WebEdit9.Left := 302;
    WebEdit9.Top := 269;
    WebEdit9.Width := 61;
    WebEdit9.Height := 19;
    WebEdit9.ChildOrder := 7;
    WebEdit9.Color := clInfoBk;
    WebEdit9.Text := '50000';
    WebEdit10.SetParentComponent(WebGroupBox4);
    WebEdit10.Name := 'WebEdit10';
    WebEdit10.Left := 302;
    WebEdit10.Top := 294;
    WebEdit10.Width := 61;
    WebEdit10.Height := 19;
    WebEdit10.ChildOrder := 7;
    WebEdit10.Color := clInfoBk;
    WebEdit10.Text := '-10000';
    WebEdit11.SetParentComponent(WebGroupBox4);
    WebEdit11.Name := 'WebEdit11';
    WebEdit11.Left := 302;
    WebEdit11.Top := 331;
    WebEdit11.Width := 61;
    WebEdit11.Height := 19;
    WebEdit11.ChildOrder := 7;
    WebEdit11.Color := 12903679;
    WebEdit11.Enabled := False;
    WebEdit11.Text := '370000';
    WebEdit12.SetParentComponent(WebGroupBox4);
    WebEdit12.Name := 'WebEdit12';
    WebEdit12.Left := 373;
    WebEdit12.Top := 26;
    WebEdit12.Width := 61;
    WebEdit12.Height := 19;
    WebEdit12.ChildOrder := 8;
    WebEdit12.Color := 12903679;
    WebEdit12.Enabled := False;
    WebEdit12.Text := '2022';
    WebEdit13.SetParentComponent(WebGroupBox4);
    WebEdit13.Name := 'WebEdit13';
    WebEdit13.Left := 373;
    WebEdit13.Top := 65;
    WebEdit13.Width := 61;
    WebEdit13.Height := 19;
    WebEdit13.ChildOrder := 1;
    WebEdit13.Color := clInfoBk;
    WebEdit13.Text := '330000';
    WebEdit14.SetParentComponent(WebGroupBox4);
    WebEdit14.Name := 'WebEdit14';
    WebEdit14.Left := 373;
    WebEdit14.Top := 90;
    WebEdit14.Width := 61;
    WebEdit14.Height := 19;
    WebEdit14.ChildOrder := 2;
    WebEdit14.Color := clInfoBk;
    WebEdit14.Text := '0';
    WebEdit15.SetParentComponent(WebGroupBox4);
    WebEdit15.Name := 'WebEdit15';
    WebEdit15.Left := 373;
    WebEdit15.Top := 115;
    WebEdit15.Width := 61;
    WebEdit15.Height := 19;
    WebEdit15.ChildOrder := 3;
    WebEdit15.Color := clInfoBk;
    WebEdit15.Text := '0';
    WebEdit16.SetParentComponent(WebGroupBox4);
    WebEdit16.Name := 'WebEdit16';
    WebEdit16.Left := 373;
    WebEdit16.Top := 140;
    WebEdit16.Width := 61;
    WebEdit16.Height := 19;
    WebEdit16.ChildOrder := 4;
    WebEdit16.Color := clInfoBk;
    WebEdit16.Text := '10000';
    WebEdit17.SetParentComponent(WebGroupBox4);
    WebEdit17.Name := 'WebEdit17';
    WebEdit17.Left := 373;
    WebEdit17.Top := 165;
    WebEdit17.Width := 61;
    WebEdit17.Height := 19;
    WebEdit17.ChildOrder := 5;
    WebEdit17.Color := clInfoBk;
    WebEdit17.Text := '20000';
    WebEdit18.SetParentComponent(WebGroupBox4);
    WebEdit18.Name := 'WebEdit18';
    WebEdit18.Left := 373;
    WebEdit18.Top := 204;
    WebEdit18.Width := 61;
    WebEdit18.Height := 19;
    WebEdit18.ChildOrder := 6;
    WebEdit18.Color := 12903679;
    WebEdit18.Enabled := False;
    WebEdit18.Text := '340000';
    WebEdit19.SetParentComponent(WebGroupBox4);
    WebEdit19.Name := 'WebEdit19';
    WebEdit19.Left := 373;
    WebEdit19.Top := 244;
    WebEdit19.Width := 61;
    WebEdit19.Height := 19;
    WebEdit19.ChildOrder := 7;
    WebEdit19.Color := clInfoBk;
    WebEdit19.Text := '80000';
    WebEdit20.SetParentComponent(WebGroupBox4);
    WebEdit20.Name := 'WebEdit20';
    WebEdit20.Left := 372;
    WebEdit20.Top := 269;
    WebEdit20.Width := 61;
    WebEdit20.Height := 19;
    WebEdit20.ChildOrder := 7;
    WebEdit20.Color := clInfoBk;
    WebEdit20.Text := '0';
    WebEdit21.SetParentComponent(WebGroupBox4);
    WebEdit21.Name := 'WebEdit21';
    WebEdit21.Left := 372;
    WebEdit21.Top := 294;
    WebEdit21.Width := 61;
    WebEdit21.Height := 19;
    WebEdit21.ChildOrder := 7;
    WebEdit21.Color := clInfoBk;
    WebEdit21.Text := '-10000';
    WebEdit22.SetParentComponent(WebGroupBox4);
    WebEdit22.Name := 'WebEdit22';
    WebEdit22.Left := 372;
    WebEdit22.Top := 331;
    WebEdit22.Width := 61;
    WebEdit22.Height := 19;
    WebEdit22.ChildOrder := 7;
    WebEdit22.Color := 12903679;
    WebEdit22.Enabled := False;
    WebEdit22.Text := '410000';
    WebEdit23.SetParentComponent(WebGroupBox4);
    WebEdit23.Name := 'WebEdit23';
    WebEdit23.Left := 443;
    WebEdit23.Top := 26;
    WebEdit23.Width := 61;
    WebEdit23.Height := 19;
    WebEdit23.ChildOrder := 8;
    WebEdit23.Color := 12903679;
    WebEdit23.Enabled := False;
    WebEdit23.Text := '2023';
    WebEdit24.SetParentComponent(WebGroupBox4);
    WebEdit24.Name := 'WebEdit24';
    WebEdit24.Left := 443;
    WebEdit24.Top := 65;
    WebEdit24.Width := 61;
    WebEdit24.Height := 19;
    WebEdit24.ChildOrder := 1;
    WebEdit24.Color := clInfoBk;
    WebEdit24.Text := '330000';
    WebEdit25.SetParentComponent(WebGroupBox4);
    WebEdit25.Name := 'WebEdit25';
    WebEdit25.Left := 443;
    WebEdit25.Top := 90;
    WebEdit25.Width := 61;
    WebEdit25.Height := 19;
    WebEdit25.ChildOrder := 2;
    WebEdit25.Color := clInfoBk;
    WebEdit25.Text := '0';
    WebEdit26.SetParentComponent(WebGroupBox4);
    WebEdit26.Name := 'WebEdit26';
    WebEdit26.Left := 443;
    WebEdit26.Top := 115;
    WebEdit26.Width := 61;
    WebEdit26.Height := 19;
    WebEdit26.ChildOrder := 3;
    WebEdit26.Color := clInfoBk;
    WebEdit26.Text := '0';
    WebEdit27.SetParentComponent(WebGroupBox4);
    WebEdit27.Name := 'WebEdit27';
    WebEdit27.Left := 443;
    WebEdit27.Top := 140;
    WebEdit27.Width := 61;
    WebEdit27.Height := 19;
    WebEdit27.ChildOrder := 4;
    WebEdit27.Color := clInfoBk;
    WebEdit27.Text := '0';
    WebEdit28.SetParentComponent(WebGroupBox4);
    WebEdit28.Name := 'WebEdit28';
    WebEdit28.Left := 443;
    WebEdit28.Top := 165;
    WebEdit28.Width := 61;
    WebEdit28.Height := 19;
    WebEdit28.ChildOrder := 5;
    WebEdit28.Color := clInfoBk;
    WebEdit28.Text := '10000';
    WebEdit29.SetParentComponent(WebGroupBox4);
    WebEdit29.Name := 'WebEdit29';
    WebEdit29.Left := 443;
    WebEdit29.Top := 204;
    WebEdit29.Width := 61;
    WebEdit29.Height := 19;
    WebEdit29.ChildOrder := 6;
    WebEdit29.Color := 12903679;
    WebEdit29.Enabled := False;
    WebEdit29.Text := '340000';
    WebEdit30.SetParentComponent(WebGroupBox4);
    WebEdit30.Name := 'WebEdit30';
    WebEdit30.Left := 443;
    WebEdit30.Top := 244;
    WebEdit30.Width := 61;
    WebEdit30.Height := 19;
    WebEdit30.ChildOrder := 7;
    WebEdit30.Color := clInfoBk;
    WebEdit30.Text := '80000';
    WebEdit31.SetParentComponent(WebGroupBox4);
    WebEdit31.Name := 'WebEdit31';
    WebEdit31.Left := 442;
    WebEdit31.Top := 269;
    WebEdit31.Width := 61;
    WebEdit31.Height := 19;
    WebEdit31.ChildOrder := 7;
    WebEdit31.Color := clInfoBk;
    WebEdit31.Text := '50000';
    WebEdit32.SetParentComponent(WebGroupBox4);
    WebEdit32.Name := 'WebEdit32';
    WebEdit32.Left := 442;
    WebEdit32.Top := 294;
    WebEdit32.Width := 61;
    WebEdit32.Height := 19;
    WebEdit32.ChildOrder := 7;
    WebEdit32.Color := clInfoBk;
    WebEdit32.Text := '0';
    WebEdit33.SetParentComponent(WebGroupBox4);
    WebEdit33.Name := 'WebEdit33';
    WebEdit33.Left := 442;
    WebEdit33.Top := 331;
    WebEdit33.Width := 61;
    WebEdit33.Height := 19;
    WebEdit33.ChildOrder := 7;
    WebEdit33.Color := 12903679;
    WebEdit33.Enabled := False;
    WebEdit33.Text := '370000';
    WebEdit34.SetParentComponent(WebGroupBox4);
    WebEdit34.Name := 'WebEdit34';
    WebEdit34.Left := 513;
    WebEdit34.Top := 26;
    WebEdit34.Width := 61;
    WebEdit34.Height := 19;
    WebEdit34.ChildOrder := 8;
    WebEdit34.Color := 12903679;
    WebEdit34.Enabled := False;
    WebEdit34.Text := '2024';
    WebEdit35.SetParentComponent(WebGroupBox4);
    WebEdit35.Name := 'WebEdit35';
    WebEdit35.Left := 513;
    WebEdit35.Top := 65;
    WebEdit35.Width := 61;
    WebEdit35.Height := 19;
    WebEdit35.ChildOrder := 1;
    WebEdit35.Color := clInfoBk;
    WebEdit35.Text := '280000';
    WebEdit47.SetParentComponent(WebGroupBox4);
    WebEdit47.Name := 'WebEdit47';
    WebEdit47.Left := 513;
    WebEdit47.Top := 90;
    WebEdit47.Width := 61;
    WebEdit47.Height := 19;
    WebEdit47.ChildOrder := 2;
    WebEdit47.Color := clInfoBk;
    WebEdit47.Text := '0';
    WebEdit48.SetParentComponent(WebGroupBox4);
    WebEdit48.Name := 'WebEdit48';
    WebEdit48.Left := 513;
    WebEdit48.Top := 115;
    WebEdit48.Width := 61;
    WebEdit48.Height := 19;
    WebEdit48.ChildOrder := 3;
    WebEdit48.Color := clInfoBk;
    WebEdit48.Text := '0';
    WebEdit49.SetParentComponent(WebGroupBox4);
    WebEdit49.Name := 'WebEdit49';
    WebEdit49.Left := 513;
    WebEdit49.Top := 140;
    WebEdit49.Width := 61;
    WebEdit49.Height := 19;
    WebEdit49.ChildOrder := 4;
    WebEdit49.Color := clInfoBk;
    WebEdit49.Text := '0';
    WebEdit50.SetParentComponent(WebGroupBox4);
    WebEdit50.Name := 'WebEdit50';
    WebEdit50.Left := 513;
    WebEdit50.Top := 165;
    WebEdit50.Width := 61;
    WebEdit50.Height := 19;
    WebEdit50.ChildOrder := 5;
    WebEdit50.Color := clInfoBk;
    WebEdit50.Text := '10000';
    WebEdit51.SetParentComponent(WebGroupBox4);
    WebEdit51.Name := 'WebEdit51';
    WebEdit51.Left := 513;
    WebEdit51.Top := 204;
    WebEdit51.Width := 61;
    WebEdit51.Height := 19;
    WebEdit51.ChildOrder := 6;
    WebEdit51.Color := 12903679;
    WebEdit51.Enabled := False;
    WebEdit51.Text := '290000';
    WebEdit52.SetParentComponent(WebGroupBox4);
    WebEdit52.Name := 'WebEdit52';
    WebEdit52.Left := 513;
    WebEdit52.Top := 244;
    WebEdit52.Width := 61;
    WebEdit52.Height := 19;
    WebEdit52.ChildOrder := 7;
    WebEdit52.Color := clInfoBk;
    WebEdit52.Text := '60000';
    WebEdit53.SetParentComponent(WebGroupBox4);
    WebEdit53.Name := 'WebEdit53';
    WebEdit53.Left := 512;
    WebEdit53.Top := 269;
    WebEdit53.Width := 61;
    WebEdit53.Height := 19;
    WebEdit53.ChildOrder := 7;
    WebEdit53.Color := clInfoBk;
    WebEdit53.Text := '0';
    WebEdit54.SetParentComponent(WebGroupBox4);
    WebEdit54.Name := 'WebEdit54';
    WebEdit54.Left := 512;
    WebEdit54.Top := 294;
    WebEdit54.Width := 61;
    WebEdit54.Height := 19;
    WebEdit54.ChildOrder := 7;
    WebEdit54.Color := clInfoBk;
    WebEdit54.Text := '20000';
    WebEdit55.SetParentComponent(WebGroupBox4);
    WebEdit55.Name := 'WebEdit55';
    WebEdit55.Left := 512;
    WebEdit55.Top := 331;
    WebEdit55.Width := 61;
    WebEdit55.Height := 19;
    WebEdit55.ChildOrder := 7;
    WebEdit55.Color := 12903679;
    WebEdit55.Enabled := False;
    WebEdit55.Text := '370000';
  finally
    WebLabel1.AfterLoadDFMValues;
    WebLabel7.AfterLoadDFMValues;
    WebGroupBox4.AfterLoadDFMValues;
    WebLabel66.AfterLoadDFMValues;
    WebLabel68.AfterLoadDFMValues;
    WebLabel71.AfterLoadDFMValues;
    WebLabel75.AfterLoadDFMValues;
    WebLabel77.AfterLoadDFMValues;
    WebLabel79.AfterLoadDFMValues;
    WebLabel80.AfterLoadDFMValues;
    WebLabel85.AfterLoadDFMValues;
    WebLabel87.AfterLoadDFMValues;
    WebLabel89.AfterLoadDFMValues;
    WebLabel91.AfterLoadDFMValues;
    WebEdit36.AfterLoadDFMValues;
    WebEdit37.AfterLoadDFMValues;
    WebEdit38.AfterLoadDFMValues;
    WebEdit39.AfterLoadDFMValues;
    WebEdit40.AfterLoadDFMValues;
    WebEdit41.AfterLoadDFMValues;
    WebEdit42.AfterLoadDFMValues;
    WebEdit43.AfterLoadDFMValues;
    WebEdit44.AfterLoadDFMValues;
    WebEdit45.AfterLoadDFMValues;
    WebEdit46.AfterLoadDFMValues;
    WebEdit1.AfterLoadDFMValues;
    WebEdit2.AfterLoadDFMValues;
    WebEdit3.AfterLoadDFMValues;
    WebEdit4.AfterLoadDFMValues;
    WebEdit5.AfterLoadDFMValues;
    WebEdit6.AfterLoadDFMValues;
    WebEdit7.AfterLoadDFMValues;
    WebEdit8.AfterLoadDFMValues;
    WebEdit9.AfterLoadDFMValues;
    WebEdit10.AfterLoadDFMValues;
    WebEdit11.AfterLoadDFMValues;
    WebEdit12.AfterLoadDFMValues;
    WebEdit13.AfterLoadDFMValues;
    WebEdit14.AfterLoadDFMValues;
    WebEdit15.AfterLoadDFMValues;
    WebEdit16.AfterLoadDFMValues;
    WebEdit17.AfterLoadDFMValues;
    WebEdit18.AfterLoadDFMValues;
    WebEdit19.AfterLoadDFMValues;
    WebEdit20.AfterLoadDFMValues;
    WebEdit21.AfterLoadDFMValues;
    WebEdit22.AfterLoadDFMValues;
    WebEdit23.AfterLoadDFMValues;
    WebEdit24.AfterLoadDFMValues;
    WebEdit25.AfterLoadDFMValues;
    WebEdit26.AfterLoadDFMValues;
    WebEdit27.AfterLoadDFMValues;
    WebEdit28.AfterLoadDFMValues;
    WebEdit29.AfterLoadDFMValues;
    WebEdit30.AfterLoadDFMValues;
    WebEdit31.AfterLoadDFMValues;
    WebEdit32.AfterLoadDFMValues;
    WebEdit33.AfterLoadDFMValues;
    WebEdit34.AfterLoadDFMValues;
    WebEdit35.AfterLoadDFMValues;
    WebEdit47.AfterLoadDFMValues;
    WebEdit48.AfterLoadDFMValues;
    WebEdit49.AfterLoadDFMValues;
    WebEdit50.AfterLoadDFMValues;
    WebEdit51.AfterLoadDFMValues;
    WebEdit52.AfterLoadDFMValues;
    WebEdit53.AfterLoadDFMValues;
    WebEdit54.AfterLoadDFMValues;
    WebEdit55.AfterLoadDFMValues;
  end;
end;

end.